import React from 'react'
import Switch from 'material-ui/Switch'
import { connect } from 'react-redux'
import * as config from '../actions/config'
import { FormControlLabel } from 'material-ui/Form'

const ThemeSwitcher = ({ isDarkTheme, handleToggleTheme, label, ...props }) => {
  const ThemeSwitcher = (
    <Switch checked={isDarkTheme} onChange={handleToggleTheme} {...props} />
  )
  if (label) {
    return <FormControlLabel control={ThemeSwitcher} label={label} />
  } else {
    return ThemeSwitcher
  }
}
ThemeSwitcher.uiName = 'Switch'

const mapStateToProps = state => ({
  isDarkTheme: state.config.enableDarkTheme,
})
const mapDispatchToProps = dispatch => ({
  handleToggleTheme: () => dispatch(config.toggleTheme()),
})

export default connect(mapStateToProps, mapDispatchToProps)(ThemeSwitcher)



// WEBPACK FOOTER //
// ./src/components/ThemeSwitcher.js